import { render, staticRenderFns } from "./EstoqueNotaFiscal.vue?vue&type=template&id=13fb7ae2&scoped=true&"
import script from "./EstoqueNotaFiscal.vue?vue&type=script&lang=js&"
export * from "./EstoqueNotaFiscal.vue?vue&type=script&lang=js&"
import style0 from "./EstoqueNotaFiscal.vue?vue&type=style&index=0&id=13fb7ae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fb7ae2",
  null
  
)

export default component.exports